    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">

            <!--begin::Toolbar-->
            <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                    <!--begin::Page title-->
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <!--begin::Title-->
                     <div class="d-flex align-items-center" >
                        <h1 class="page-heading"><svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_651_309)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3028 5.08326C31.7505 5.08326 31.3028 5.53097 31.3028 6.08326V17.5453H27.3636V0.999999C27.3636 0.447714 26.9158 0 26.3636 0H23.9696C23.4173 0 22.9696 0.447715 22.9696 1V17.5453H19.0304V11.5537C19.0304 11.0014 18.5827 10.5537 18.0304 10.5537H15.6364C15.0842 10.5537 14.6364 11.0014 14.6364 11.5537V17.5453H10.6913V8.07453C10.6913 7.52224 10.2436 7.07453 9.69133 7.07453H7.29738C6.74509 7.07453 6.29738 7.52224 6.29738 8.07453V17.5453H4V19H38V17.5453H35.7085V6.08326C35.7085 5.53097 35.2608 5.08326 34.7085 5.08326H32.3028Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_651_309" x="0" y="0" width="42" height="27" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_651_309"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_651_309" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            
                            
                            Evaluation
                        </h1>
                            <!--begin::Menu-->
                     </div>
                        <!--end::Title-->
                        <!--begin::Breadcrumb-->
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">
                                <a routerLink="/accueil" class="text-muted ">Accueil</a>
                              </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted"><a routerLink="/evaluation/list" class="text-muted">Liste des évaluations</a></li>
                            <!--end::Item-->
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">Détails évaluation</li>
                        </ul>
                        <!--end::Breadcrumb-->
                    </div>
                    <!--end::Page title-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Toolbar container-->
            </div>
            <!--end::Toolbar-->
         
            <!--begin::Content-->

            <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card pb-10">
                     
                        <!--begin::Card body-->
                        <div class="card-body">
                           
                            <div class="contents">
                                <div class="card-body pt-3">
                                    <!--begin::Table-->
                                    <div class="btn-container mb-10">
                                        <a (click)="navigateToEvalList()" class="btn back-btn">
                                            <i class="me-2 fa fa-arrow-left" style="color: #265D91"></i>Retour
                                        </a>
                                        <ng-container *ngIf="evaluationDetail?.status === '3' && isEvalOwner()" >
                                            <ng-container *ngIf="isSendEnable(); else saveEnabled">
                                                <a class="btn confirmer" data-bs-toggle="modal" data-bs-target="#pv_modal">
                                                    Modifier compte rendu<i class="ms-2 fa fa-file-text" style="color: #fff"></i>
                                                </a>
                                                <a  class="btn action-btn" 
                                                    (click)="sendPV()">
                                                    Envoyer compte rendu<i class="ms-2 fa fa-paper-plane" style="color: #fff"></i>
                                                </a>
                                            </ng-container>
                                            <ng-template #saveEnabled>
                                                <a class="btn action-btn" data-bs-toggle="modal" data-bs-target="#pv_modal">
                                                    Saisir compte rendu<i class="ms-2 fa fa-file-text" style="color: #fff"></i>
                                                </a>
                                            </ng-template>
                                        </ng-container>
                                    </div>
                                  <div class="row">
                                    <div class="col-lg-6">
                                        <div class="bloc-input mb-5">
                                            <h4 class="mb-2">
                                                <i class="fa fa-file wgu-icon" aria-hidden="true"></i>
                                                Nom évaluation
                                            </h4>
                                         
                                            <span >{{ evaluationDetail?.name ? evaluationDetail?.name : '---' }}</span>
                                      
                                        </div>
                                        <div class="bloc-input mb-5">
                                            <h4 class="mb-2">
                                                <i class="fa fa-tasks wgu-icon" aria-hidden="true"></i>
                                                Type évaluation
                                            </h4>
                                           <span>{{evaluationDetail?.type ? evaluationDetail?.type : '---' }}</span>
                                        </div>
                                        <div class="bloc-input mb-5">
                                            <h4 class="mb-2">  
                                                <i class="fa fa-user wgu-icon" aria-hidden="true"></i>
                                                Nom consultant
                                            </h4>
                                           
                                            <span>
                                                {{ evaluationDetail?.consultant?.first_name ? evaluationDetail?.consultant?.first_name : '---' }} 
                                                {{ evaluationDetail?.consultant?.last_name ? evaluationDetail?.consultant?.last_name : '---' }}
                                            </span>
                                           
                                        </div>
                                        
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="bloc-input mb-5">
                                            <h4 class="mb-2">
                                                <i class="fa fa-user wgu-icon" aria-hidden="true"></i>
                                                Nom responsable
                                            </h4>
                                            <span >
                                                {{ evaluationDetail?.sender?.first_name ? evaluationDetail?.sender?.first_name : '---' }}
                                                {{ evaluationDetail?.sender?.last_name ? evaluationDetail?.sender?.last_name : '---' }}
                                            </span>
                                      
                                        </div>
                                        <div class="bloc-input mb-5">
                                            <h4 class="mb-2">
                                                <i class="fa fa-calendar wgu-icon" aria-hidden="true"></i>
                                                Date d'envoi
                                            </h4>
                                           <span>{{evaluationDetail?.sent_at ? evaluationDetail?.sent_at : '---' }}</span>
                                        </div>
                                        <div class="bloc-input mb-5">
                                            <h4 class="mb-2">  
                                                <i class="fa fa-calendar wgu-icon" aria-hidden="true"></i>
                                                 Date de réception
                                            </h4>
                                            <span>
                                                {{ evaluationDetail?.sent_at_by_consultant ? evaluationDetail?.sent_at_by_consultant : '---' }}
                                            </span>
                                           
                                        </div>
                                        
                                    </div>
                                    
                                  </div>
                                  
                                </div>
                            </div>

                        <div class="container">
                            <div class="evals">
                                <div class="accordion evals" id="kt_accordion_1">
                                    <div class="accordion-item eval mb-5" *ngFor="let family of evaluationDetail?.questions_by_family; let i = index">
                                      <h2 class="accordion-header" [id]="'kt_accordion_1_header_' + i">
                                        <button class="accordion-button fs-4 fw-semibold" type="button"
                                          [attr.data-bs-toggle]="'collapse'"
                                          [attr.data-bs-target]="'#kt_accordion_1_body_' + i"
                                          [attr.aria-expanded]="i === 0" aria-controls="'kt_accordion_1_body_' + i">
                                            {{ family?.family_name }}
                                        </button>
                                      </h2>
                                      <div [id]="'kt_accordion_1_body_' + i" class="accordion-collapse" [ngClass]="i === 0 ? 'show' : 'collapse'"
                                        [attr.aria-labelledby]="'kt_accordion_1_header_' + i">
                                        <div class="accordion-body evals"
                                          *ngFor="let question of family?.questions; let j = index">
                                          <div class="bloc">
                                            <div class="d-flex question-container">
                                                <div class="w-100 d-flex justify-content-between">
                                                    <div class=" text question-name-container">
                                                        <span >{{ j + 1 }}</span>
                                                        <p>{{ question?.content }}</p>
                                                    </div>
                                                    <div>
                                                        <span class="tag-type" 
                                                            [ngClass]="question.type_response === 1 ? 'tag-type-comment' : 'tag-type-note'">
                                                            {{ question.type_response === 1 ? 'Note' : 'Commentaire' }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <ng-container *ngIf="evaluationDetail?.status === '3'">
                                                    <hr class="w-100" style="color: grey;">
                                                    <div class="w-100 mt-5 response-container">
                                                        <label class="me-5">Réponse : </label>
                                                        <div class="rating mb-5" >
                                                                <div *ngIf="question?.type_response === 1; else commentType" >
                                                                    <div class="stars" *ngIf="question?.response[0]?.stars as stars; else noStars">
                                                                        <ng-container >
                                                                            <i *ngFor="let star of [1, 2, 3, 4, 5]" 
                                                                            class="fa fa-star" 
                                                                            [class.gold]="stars >= star">
                                                                            </i>
                                                                        </ng-container>
                                                                    </div>
                                                                    <ng-template #noStars>
                                                                        <span>---</span>
                                                                    </ng-template>
                                                                </div>
                                                                <div>
                                                                    <ng-template #commentType>
                                                                        <p>{{question?.response[0]?.comment ? question?.response[0]?.comment : '---'}}</p>
                                                                    </ng-template>
                                                                </div>
                                                        </div>       
                                                    </div>
                                                </ng-container>
                                          </div>
                                        </div>                                   
                                    </div>
                                 
                                </div>

                            </div>
                        </div>
                            <!--end::Table-->
                        </div>
                        <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                    <!--begin::Modals-->
                    <!--begin::Modal - Customers - Add-->
              
                    <!--end::Modal - Customers - Add-->
                    <!--begin::Modal - Adjust Balance-->
                
                    <!--end::Modal - New Card-->
                    <!--end::Modals-->
                </div>
                <!--end::Content container-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
    <!--end:::Main-->
    </div>

    <!-- @tofix : verify before delete -->

    <!-- <script src="./assets/js/custom/apps/projects/settings/settings.js"></script>
    <script src="./assets/js/widgets.bundle.js"></script>
    <script src="./assets/js/custom/widgets.js"></script>
    <script src="./assets/js/custom/apps/chat/chat.js"></script>
    <script src="./assets/js/custom/apps/ecommerce/customers/listing/listing.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/add.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/export.js"></script> -->


<!--begin::Modal - Customers - Add-->
<div class="modal fade" id="pv_modal" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content pt-5  pb-15" >
            <!--begin::Modal header-->
            <div class="modal-header" >
                <!--begin::Modal title-->
                <h2 class="fw-bold">Compte rendu</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
                    <i class="ki-duotone ki-cross fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
                <!--end::Close-->
            </div>
            <!--end::Modal header-->
            <!--begin::Modal body-->
            <div class="modal-body  mx-5 " [formGroup]="formPV">
                <quill-editor  [placeholder]="'compte rendu *'" formControlName="report" [modules]="{ toolbar: toolbarOptions }" style="width: 100%; height: 300px;" ></quill-editor>      
                <div *ngIf="formPV.get('report')?.touched && formPV.get('report')?.invalid " class="mt-5 text-danger">
                    <span *ngIf="formPV.get('report')?.errors?.['required']">Ce champ est obligatoire.</span>
                  </div>
            </div>
            <div class="card-footer text-center mx-5 ">
                <div class="actions">
                    <a (click)="closeModal()" class="annuler" data-bs-dismiss="modal" aria-label="Close" style="cursor: pointer;">Annuler</a>

                    <a [ngClass]="{ 'disabled-link': formPV.invalid }" 
                       (click)="formPV.valid && ( isSendEnable()?  updatePV() : savePV())" data-bs-dismiss="modal" aria-label="Close" class="confirmer" style="cursor: pointer;">{{isSendEnable()?  'Modifier' : 'Enregistrer'}}</a>
                  </div>
            </div>
            <!--end::Modal body-->
        </div>
        <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
</div>
        
    <ngx-spinner class="custom-spinner"
        bdColor="rgba(255,255,255,1)"
        size="medium"
        color="#fff"
        type="ball-atom"
        [fullScreen]="true"
        >
        <span class="loader">
            <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
        </span>
    </ngx-spinner>